import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../store/views/entityView";
import { studyGroupsBySchoolIdFilters } from "../../../utils/entitiesFiltersUtils";

export default function useMyLearningNmm() {

    const { userDetails } = useSelector((state) => state.auth);
    const { domains } = useSelector((state) => state.uiData);
    const studyGroupsFilters = useMemo(() => studyGroupsBySchoolIdFilters(userDetails?.defaultSchool?.id), [userDetails?.defaultSchool?.id]);
    const studyGroups = useSelector((state) => selectEntitiesByFilters(state, studyGroupsFilters));
    const [orderedStudyGroups, setOrderedStudyGroups] = useState([]);

    useEffect(() => {
        if (studyGroups?.length) {
            const orderMap = Object.fromEntries((domains || []).map(d => [d.name, { teacher: d.orderForTeacher, student: d.order }]));
            const sorted = [...studyGroups].sort((a, b) =>
                (orderMap[a.domainName]?.teacher != null || orderMap[b.domainName]?.teacher != null)
                    ? (orderMap[a.domainName]?.teacher ?? Infinity) - (orderMap[b.domainName]?.teacher ?? Infinity)
                    : (orderMap[a.domainName]?.student ?? Infinity) - (orderMap[b.domainName]?.student ?? Infinity)
            );
            setOrderedStudyGroups(sorted);
        }
        else
            setOrderedStudyGroups([]);
    }, [studyGroups, domains]);

    return orderedStudyGroups;
}
